<mat-card class="path-layout">
  <mat-card-header class="flex-row header gap-16 header-container">
    <mat-card-title class="antialiased data-header">
      <h4 class="font-weight-bold">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.PATH_LAYOUT' | bmsTranslate }}</h4>
    </mat-card-title>

    <div class="flex-row gap-8 flex-center">
      <vdw-progress-button
        class="flex-row flex-center"
        label="PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.AUTO_FILL_PATH"
        [iconName]="'add-small'"
        [inProgress]="isFillingPath"
        [disabled]="isAutoFillButtonDisabled()"
        [buttonSize]="'MEDIUM'"
        (progressClick)="autoFillPath()"
      ></vdw-progress-button>

      <button
        mat-icon-button
        class="mat-icon-action-button-lg-with-border disable-focus actions-button"
        [class.open]="isActionsMenuOpen"
        [matMenuTriggerFor]="actionsMenu"
        *appHasPermission="ADD_MANUAL_JUTE_PERMISSION"
        (menuOpened)="openActionsMenu()"
        (menuClosed)="closeActionsMenu()"
      >
        <mat-icon svgIcon="more"></mat-icon>
      </button>

      <mat-menu class="mat-elevation-z0 actions-menu" #actionsMenu="matMenu">
        <ng-template matMenuContent>
          <button mat-menu-item (click)="addCustomJuteToPath()" [disabled]="!canAddCustomDesignToPath()">
            <span class="mat-menu-item-label">{{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'DESIGN_LIBRARY.DESIGN' | bmsTranslate: {count: 1} | lowercase} }}</span>
          </button>
        </ng-template>
      </mat-menu>
    </div>

    <mat-divider vertical class="vertical-divider"></mat-divider>

    <div class="flex-row">
      <div class="data-element-container" [style.max-width.px]="maxWidthForDataElements">
        <vdw-ellipsis-label
          matTooltipPosition="above"
          text="{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SIZE' | bmsTranslate }}: {{ getUnitDimensionsForPathLayout() }} {{
            'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.REMAINING_LENGTH_IN_BUGGY' | bmsTranslate
          }}:
          {{ getRemainingLengthInBuggy() }}"
          [hasContent]="true"
        >
          <span>
            <span class="b2 font-weight-regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SIZE' | bmsTranslate }}: </span>
            <span class="b2 font-weight-semibold mr-8">{{ getUnitDimensionsForPathLayout() }} </span>
          </span>
          <span class="max-length" (mouseenter)="openHoverInfoTooltip($event)">
            <span class="b2 font-weight-regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.REMAINING_LENGTH_IN_BUGGY' | bmsTranslate }}: </span>
            <span class="b2 font-weight-semibold mr-8">{{ getRemainingLengthInBuggy() }}</span>
          </span>
        </vdw-ellipsis-label>
      </div>
    </div>

    <div class="right-side">
      <button
        *appHasPermission="ADD_PATH_LAYOUT_TEMPLATE"
        mat-icon-button
        class="mat-icon-action-button-lg-with-border"
        [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SELECT_TEMPLATE' | bmsTranslate"
        matTooltipPosition="above"
        (click)="selectPathLayoutTemplate()"
      >
        <mat-icon svgIcon="import-or-load"></mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content #pathsContainer class="path-container">
    <div class="full-height flex-column">
      @for (
        productionSchedulePathsOfColoredYarnSet of productionSchedule.productionSchedulePathsOfColoredYarnSets;
        track productionSchedulePathsOfColoredYarnSet?.productionScheduleColoredYarnSet?.startDent;
        let productionScheduleColoredYarnSetIndex = $index
      ) {
        <div
          #pathsForColoredYarnSets
          cdkDropListGroup
          class="paths-for-colored-yarn-sets flex-column"
          [style.flex-grow]="heightOfColoredYarnSetsInPercentage[productionScheduleColoredYarnSetIndex]"
          [style.flex-basis.%]="heightOfColoredYarnSetsInPercentage[productionScheduleColoredYarnSetIndex]"
        >
          @for (
            path of productionSchedule | getProductionSchedulePathsAndZonesForColoredYarnSet: productionScheduleColoredYarnSetIndex : productionSchedulePhase;
            track path.startDent;
            let pathIndex = $index
          ) {
            <ng-container #paths>
              <div class="flex-row header data-container" [style.background-color]="getPathBackgroundColor($any(path))">
                <div>
                  <mat-radio-button class="b2" (click)="pathSelected($any(path), productionSchedulePathsOfColoredYarnSet)" [checked]="isPathChecked($any(path), null)"
                    ><div class="path-title">
                      <div>{{ getProductionSchedulePathLabel($any(path), productionSchedulePathsOfColoredYarnSet) }}</div>
                      <mat-icon
                        *ngIf="canShowSubceedsMinBuggyLengthError($any(path))"
                        class="small-icon"
                        svgIcon="warning-small"
                        [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.PATH_LENGTH_IS_TOO_SHORT' | bmsTranslate"
                        matTooltipPosition="after"
                        matTooltipClass="unset-max-width unset-max-width-warning"
                      ></mat-icon>
                      <mat-icon
                        *ngIf="canShowExceedsMaxBuggyLengthError($any(path))"
                        class="small-icon"
                        svgIcon="warning-small"
                        [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.MAX_PATH_LENGHT_HAS_BEEN_CROSSED' | bmsTranslate"
                        matTooltipPosition="after"
                        matTooltipClass="unset-max-width unset-max-width-warning"
                      ></mat-icon>
                    </div>
                  </mat-radio-button>
                </div>

                <div class="path-elements">
                  <section class="flex-row gap-8">
                    <div class="data-element-container" [style.max-width.px]="maxWidthForDataElements">
                      <hr class="separator" />
                      <vdw-ellipsis-label matTooltipPosition="above" text="{{ getLabelForPathAndDifferenceDimensions($any(path)) }}" [hasContent]="true">
                        <span>
                          <span class="b2 font-weight-regular ml-8">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SIZE' | bmsTranslate }}: </span>
                          <span class="b2 font-weight-semibold mr-8">{{ getUnitDimensionsForPath($any(path)) }}</span>
                        </span>
                        <span *ngIf="canShowDifference($any(path))">
                          <span class="b2 font-weight-regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.DIFFERENCE' | bmsTranslate }}: </span>
                          <span class="b2 font-weight-semibold mr-8">{{ getUnitDimesionsForDifference($any(path)) }}</span>
                        </span>
                      </vdw-ellipsis-label>
                      <hr class="separator" />
                    </div>
                  </section>

                  <app-color-list-preview-with-position
                    #colorListPreviewComponents
                    [isSisal]="productionSchedule.machine.jacquard.isSisal"
                    [coloredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
                    [creelMapping]="productionSchedule.mappingForCurrentPositionOnMachine ? this.productionSchedule.mappingForCurrentPositionOnMachine[productionScheduleColoredYarnSetIndex] : null"
                  ></app-color-list-preview-with-position>

                  <section class="right-side flex-row gap-4">
                    <button
                      class="small-icon-button"
                      [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MOVE_PATH_UP' | bmsTranslate"
                      [disabled]="!canMovePath(pathIndex, productionSchedulePathsOfColoredYarnSet, true)"
                      (click)="movePath($any(path), pathIndex, productionSchedulePathsOfColoredYarnSet, true)"
                    >
                      <mat-icon class="small-icon" svgIcon="arrow-up-small"></mat-icon>
                    </button>
                    <button
                      class="small-icon-button"
                      [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MOVE_PATH_DOWN' | bmsTranslate"
                      [disabled]="!canMovePath(pathIndex, productionSchedulePathsOfColoredYarnSet, false)"
                      (click)="movePath($any(path), pathIndex, productionSchedulePathsOfColoredYarnSet, false)"
                    >
                      <mat-icon class="small-icon" svgIcon="arrow-down-small"></mat-icon>
                    </button>
                    <button class="small-icon-button" [matTooltip]="'ANGULAR_COMPONENT_LIBRARY.HEADER.DELETE' | bmsTranslate" (click)="deletePath($any(path), productionSchedulePathsOfColoredYarnSet)">
                      <mat-icon class="small-icon" svgIcon="trash-small"></mat-icon>
                    </button>
                  </section>
                </div>
              </div>

              <div
                class="path-bar-container"
                [style.flex-grow]="getHeightOfPathInColoredYarnSet(productionScheduleColoredYarnSetIndex, pathIndex)"
                [style.background-color]="getPathBackgroundColor($any(path))"
              >
                <app-path-bar-component
                  #pathBars
                  class="path-bar"
                  [productionSchedule]="productionSchedule"
                  [productionSchedulePath]="path"
                  [selectedPath]="selectedPath"
                  [productionSchedulePathIndex]="pathIndex"
                  [commercialUnit]="commercialUnit"
                  [productionSchedulePhase]="productionSchedulePhase"
                  [productionScheduleColoredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
                  listOfCustomSettings="listOfCustomSettings"
                  [productionOrderCustomSettings]="productionOrderCustomSettings"
                  [originalBuggyLengthMaxInPicks]="buggyLengthMaxInPicks"
                  [buggyLengthMinInPicks]="buggyLengthMinInPicks"
                  [buggyLengthMaxInPicks]="newBuggyLengthMaxInPicks ?? buggyLengthMaxInPicks"
                  [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
                  [isDraggingProductionScheduleItem]="isDraggingProductionScheduleItem"
                  [isResizing]="isResizing"
                  (minimumBuggyLengthIndicatorPlaceOutput)="minimumBuggyLengthIndicatorPlace = $event"
                  (maximumBuggyLengthIndicatorPlaceOutput)="maximumBuggyLengthIndicatorPlace = $event"
                  (isDraggingProductionScheduleItemOutput)="isDraggingProductionScheduleItem = $event"
                  (hoverPathBarOutput)="onHoverPathBarOutput()"
                  (selectedPathOutput)="selectedPathOutput.emit($event)"
                  (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
                ></app-path-bar-component>
              </div>
            </ng-container>
          }

          <ng-container *ngIf="canShowRestPath(productionSchedulePathsOfColoredYarnSet)">
            <div class="flex-row header data-container" [style.background-color]="getPathBackgroundColor(null, productionSchedulePathsOfColoredYarnSet)">
              <div>
                <mat-radio-button class="b2" (click)="pathSelected(null, productionSchedulePathsOfColoredYarnSet)" [checked]="isPathChecked(null, productionSchedulePathsOfColoredYarnSet)">{{
                  getProductionScheduleRestPathLabel(productionSchedulePathsOfColoredYarnSet, productionScheduleColoredYarnSetIndex)
                }}</mat-radio-button>
              </div>

              <div class="path-elements">
                <div class="flex-row gap-8">
                  <div class="data-element-container" [style.max-width.px]="maxWidthForDataElements">
                    <hr class="separator" />
                    <vdw-ellipsis-label
                      matTooltipPosition="above"
                      text="{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SIZE' | bmsTranslate }}: {{ getUnitDimensionsForPathRest(productionSchedulePathsOfColoredYarnSet) }} {{
                        'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.DIFFERENCE' | bmsTranslate
                      }}: {{ getUnitDimesionsForDifference($any(productionSchedulePathsOfColoredYarnSet)) }}"
                      [hasContent]="true"
                    >
                      <span>
                        <span class="b2 font-weight-regular ml-8">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.SIZE' | bmsTranslate }}: </span>
                        <span class="b2 font-weight-semibold mr-8">{{ getUnitDimensionsForPathRest(productionSchedulePathsOfColoredYarnSet) }}</span>
                      </span>
                      <span>
                        <span class="b2 font-weight-regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.DIFFERENCE' | bmsTranslate }}: </span>
                        <span class="b2 font-weight-semibold mr-8">{{ getUnitDimesionsForDifference($any(productionSchedulePathsOfColoredYarnSet)) }}</span>
                      </span>
                    </vdw-ellipsis-label>
                    <hr class="separator" />
                  </div>
                </div>

                <app-color-list-preview-with-position
                  #colorListPreviewComponents
                  [isSisal]="productionSchedule.machine.jacquard.isSisal"
                  [coloredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
                  [creelMapping]="productionSchedule.mappingForCurrentPositionOnMachine ? this.productionSchedule.mappingForCurrentPositionOnMachine[productionScheduleColoredYarnSetIndex] : null"
                ></app-color-list-preview-with-position>
              </div>
            </div>

            <div
              class="path-bar-container"
              [style.flex-grow]="heightOfRestPathsInPercentage[productionScheduleColoredYarnSetIndex]"
              [style.background-color]="getPathBackgroundColor(null, productionSchedulePathsOfColoredYarnSet)"
            >
              <app-path-bar-component
                #pathBars
                class="path-bar"
                [productionSchedule]="productionSchedule"
                [selectedPath]="selectedPath"
                [selectedRestPathColoredYarnSet]="selectedRestPathColoredYarnSet"
                [commercialUnit]="commercialUnit"
                [productionSchedulePhase]="productionSchedulePhase"
                [productionScheduleColoredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
                listOfCustomSettings="listOfCustomSettings"
                [productionOrderCustomSettings]="productionOrderCustomSettings"
                [originalBuggyLengthMaxInPicks]="buggyLengthMaxInPicks"
                [buggyLengthMinInPicks]="buggyLengthMinInPicks"
                [buggyLengthMaxInPicks]="newBuggyLengthMaxInPicks ?? buggyLengthMaxInPicks"
                [availableSpaceInBuggyInPicks]="availableSpaceInBuggyInPicks"
                [minimumBuggyLengthIndicatorPlace]="minimumBuggyLengthIndicatorPlace"
                [maximumBuggyLengthIndicatorPlace]="maximumBuggyLengthIndicatorPlace"
                [isDraggingProductionScheduleItem]="isDraggingProductionScheduleItem"
                (isDraggingProductionScheduleItemOutput)="isDraggingProductionScheduleItem = $event"
                (hoverPathBarOutput)="onHoverPathBarOutput()"
                (selectedPathOutput)="selectedPathOutput.emit($event)"
                (selectedRestPathColoredYarnSetOutput)="selectedRestPathColoredYarnSetOutput.emit($event)"
              ></app-path-bar-component>
            </div>
          </ng-container>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
